import { useEffect, useState } from "react";
import api from "../../api";
import { STATUS_LABELS, PLATFORM_STATUS_LABELS, STATUS_TONES, formatDate } from "./requestLabels";

// The signed-in person's own requests from Help and what happened to them.
// `compact` is the Help page's side panel: shorter rows and an empty state.
export default function MyRequests({ refreshKey, compact = false }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.fetchMyHelpRequests().then((r) => setRows(r.data.requests || [])).catch(() => setRows([]));
  }, [refreshKey]);

  if (!rows) return compact ? <div className="h-10 rounded-lg bg-secondary-100 animate-pulse" /> : null;
  if (rows.length === 0) {
    return compact
      ? <p className="text-sm text-secondary-500">Nothing sent yet. When Help can't do something, you can send it as a request and follow it here.</p>
      : null;
  }
  return (
    <ul className={compact ? "space-y-3" : "space-y-2"}>
      {rows.slice(0, compact ? 5 : 50).map((r) => {
        const withUs = r.status === "forwarded" && r.platform_status && r.platform_status !== "new";
        const state = withUs ? r.platform_status : r.status;
        const label = withUs ? PLATFORM_STATUS_LABELS[r.platform_status] : STATUS_LABELS[r.status];
        const note = r.platform_note || r.admin_note;
        return (
          <li key={r.id} className={compact ? "space-y-1" : "rounded-xl border border-secondary-200 bg-white p-4 space-y-1"}>
            <div className="flex items-start justify-between gap-2">
              <p className="text-sm text-secondary-900 min-w-0 flex-1 line-clamp-2">{r.question}</p>
              <span className={`shrink-0 text-[11px] font-semibold px-2 py-0.5 rounded-full ${STATUS_TONES[state] || STATUS_TONES.new}`}>{label}</span>
            </div>
            <p className="text-xs text-secondary-500">Sent {formatDate(r.created_at)}</p>
            {note && (
              <p className="text-xs text-secondary-700 bg-secondary-50 rounded-lg px-2.5 py-1.5">
                <span className="font-semibold">{r.platform_note ? "MindConnect" : "Your clinic admin"}:</span> {note}
              </p>
            )}
          </li>
        );
      })}
    </ul>
  );
}
